@import 'styles/mixins';
@import 'styles/variables';

.radioContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid var(--dark-4);
}

.paperSize {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 12px;
}

.root {
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  @include transition;
  appearance: none !important;

  .bullet {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(--neutral-0);
    border: 1px solid var(--dark-20);
    margin: 10px 10px;
    @include transition;

    &:after {
      @include transition;
      content: '';
      border-radius: 50%;
      display: block;
      height: 6px;
      width: 6px;
      margin: 3px;
      background: var(--light-100);
    }
  }

  .title {
    display: block;
    @include md-semibold;
    color: var(--dark-80);
    margin-bottom: 4px;
  }

  .description {
    display: block;
    @include md-regular;
    color: var(--dark-40);
  }

  &.borderless {
    border: none;
    padding: 4px;
    margin: 0 0 0 -6px;

    &:last-of-type {
      margin-bottom: 2px;
    }

    .bullet {
      display: grid;
      place-items: center;
      width: 16.67px;
      height: 16.67px;
      margin: 1.64px 8px 1.64px 1.64px;
      border-radius: 12px;

      &::after {
        width: 8.33px;
        height: 8.33px;
      }
    }

    .title {
      color: var(--dark-80);
    }

    .description {
      color: var(--dark-40);
    }

    .title,
    .description {
      @include md-regular;
      font-weight: 400;
    }
  }
}

.selected {
  background: var(--overlay);
  border-color: var(--selected-stroke);

  .bullet {
    background: var(--default-bg);
    border: 1px solid var(--selected-stroke);

    &:after {
      background: var(--selected-stroke);
    }
  }
}

.disabled {
  border-color: var(--dark-40);
  background: var(--dark-6);
  cursor: not-allowed;
}

.hovered {
  border-color: var(--dark-40);
}

@media (min-width: $phoneMaxWidth) {
  .radioContainer {
    border-bottom: unset;
  }
  .paperSize {
    display: none;
  }
}
